<template>
  <div>
    <!-- 修改商品番号 -->
    <el-dialog :title="$t('message.modifyProductNumber')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="380px" center>
      <div class="content">
        <div class="val">
          <el-input v-model="datas.client_sku_code" onfocus="this.select()" type="textarea"></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">
          {{ $t("message.cancel") }}
        </el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="updateItemClientCode">
          {{ $t("message.ok") }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      datas: {
        user_id: '',
        sys_code: '',
        client_sku_code: '',
      },
      dialogVisible: false,
    };
  },
  methods: {
    // 保存
    updateItemClientCode() {
      this.$api.productManagementApi.updateItemClientCode(this.datas).then((res) => {
        this.$message.success(res.msg);
        this.dialogVisible = false;
        this.$parent.tableData[this.$parent.index].client_sku_code = this.datas.client_sku_code
        this.$parent.tableData[this.$parent.index].sys_code = this.datas.user_id + '__' + this.datas.client_sku_code
        this.$forceUpdate()
      });
    },

  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;


}
</style>